import { createReducer, on } from '@ngrx/store';
import { myServicesActions } from '@store/actions/my-services.actions';
import { myServicesInitialState, MyServicesState } from '@store/states/my-services.state';

export const myServicesReducer = createReducer(
  myServicesInitialState,
  on(
    myServicesActions.setListingDataFilters,
    (state, { filters }): MyServicesState => ({
      ...state,
      listingData: {
        ...state.listingData,
        filters: {
          ...state.listingData.filters,
          ...filters,
        },
      },
    })
  ),
  on(
    myServicesActions.setListingData,
    (state, data): MyServicesState => ({
      ...state,
      listingData: {
        ...state.listingData,
        superData: [...data.superData],
        subData: {
          ...data.subData,
        },
        error: null,
      },
    })
  ),
  on(
    myServicesActions.setListingDataError,
    (state, { error }): MyServicesState => ({
      ...state,
      listingData: {
        ...state.listingData,
        error: error,
      },
    })
  )
);
